import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConfirmRemoveDialogComponent } from 'src/app/shared-layout/Components/confirm-remove-dialog/confirm-remove-dialog.component';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import {
  convertToSiteTimeZone,
  convertDateTimeFormat,
  convertParseDateTime,
  Utility,
} from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import {
  ICriteria,
  IShareAccess,
  IUpdateUserGroupAccess,
  IuserGroup,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-profile-access-time',
  templateUrl: './user-profile-access-time.component.html',
  styleUrls: ['./user-profile-access-time.component.scss'],
})
export class UserProfileAccessTimeComponent implements OnInit, OnDestroy {
  private timeZone: string;
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() addGroupFlag!: boolean;
  @Output() submitToUserProfile = new EventEmitter<any>();
  @Input() deleteGroupFlag!: boolean;
  @Input() selectedGroup!: IuserGroup;
  @Input() ownProfile!: boolean;
  @Input() userId!: string;
  @Input() profileDetails!: IUserProfile;
  @Input() parentRouteParams!: any;
  formGroup!: FormGroup;
  toggleDateForm = false;
  toggletimeForm = false;
  submited = false;
  errorMessage!: string;
  utility = Utility;
  toggleDisabled: boolean = false;
  doneDisabled: boolean = false;
  expireDisabled: boolean = false;
  userType!: string | undefined;

  defaultStartTime: any;
  calendarDate: any;
  startTimeObj: any;
  hour = '';
  minute = '';
  meridiem = '';

  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;

  hourStartRepeatTime = '';
  minuteStartReapeatTime = '';
  meridiemStartRepeatTime = '';

  hourEndRepeatTime = '';
  minuteEndReapeatTime = '';
  meridiemEndRepeatTime = '';
  weekArray: any;
  calendarValidateMinMax = '';
  calendarConvertedStartDate: Date;
  calendarConvertedEndDate: Date | string = '';
  calendarConvertedEndDateMinimum = new Date();
  subscription: Subscription | undefined;
  userListsubscription: Subscription | undefined;
  groupTypeId!: string;
  groupName!: string;

  /**
   * @description control getter formgroup
   * @returns rective controls
   */
  get formInstance() {
    return this.formGroup?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private cdf: ChangeDetectorRef,
    private userManagementService: UserManagementService,
    private notificationService: NotificationService,
    private helperService: HelperService,
    private commonService: CommonService,
    private accountSettingService: AccountSettingsService,
    private router: Router,
    private stateManagementService: StateManagementService,
    private translate: TranslateService
  ) {
    this.calendarConvertedEndDateMinimum = new Date();
    const siteTimeZone =
      this.stateManagementService.getSharedData()?.selectedSite?.siteTimeZone;
    siteTimeZone
      ? (this.timeZone = siteTimeZone.toString())
      : (this.timeZone = '');
    this.calendarConvertedStartDate = convertToSiteTimeZone(this.timeZone);
  }

  /**
   * @description this is onInit life cycle method
   *  get formgroup from parent rootgroup
   * initialise weekly list
   */
  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    this.userType = this.profileDetails?.userType;
    // weekly state manager for select unselect week
    this.weekArray =  this.translate.instant("WEEKARRAY")

    if (this.deleteGroupFlag) {
      this.setInitialStatusSelected();
    } else {
      this.formGroup?.reset();
      this.formGroup?.controls?.repeat?.setValue(false);
      //deleting controls so that their validation won't trigger.
      this.formGroup?.removeControl('repeatStartTime');
      this.formGroup?.removeControl('repeatEndTime');
      this.formGroup?.removeControl('repeatDays');
    }

    this.defaultStartTime = convertDateTimeFormat(
      new Date().toString(),
      `EEE, MMM do, yyyy 'at' h:mm a`
    );
  }

  /**
   * @description if control have it any value mark status true
   * @returns void
   */
  setInitialStatusSelected(): void {
    this.formInstance?.repeatDays?.value?.map((day: any) => {
      this.weekArray.find((x: any) => x.value == day).active = true;
    });
  }

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }
  /**
   * @description navigate back button form previous step
   * @returns void
   */
  navigateToAddGroup(): void {
    this.stepperChange.emit((this.stepper = 7));
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  submit(): void {
    this.submited = true;
    let userDetail: IUpdateUserGroupAccess | any = {};
    userDetail.userId = this.userId;
    userDetail.userGroupId = this.selectedGroup.userGroupId;
    if (this.formGroup.value?.repeat) {
      const userStartTimeEndTime = this.startTimeEndTimeUpdate();
      userDetail.repeatStartTime = userStartTimeEndTime.repeatStartTime;
      userDetail.repeatEndTime = userStartTimeEndTime.repeatEndTime;

      userDetail.repeatDays = this.formGroup.value?.repeatDays;
    } else {
      this.formGroup.value?.startTime
        ? (userDetail.startTime = convertParseDateTime(
            this.formGroup.value?.startTime,
            "EEE, MMM do, yyyy 'at' h:mm a",
            "yyyy-MM-dd'T'HH:mm:ss"
          ))
        : (userDetail.startTime = CONSTANTS.NOW);

      if (this.formGroup.value?.expireTime) {
        userDetail.expireTime = convertParseDateTime(
          this.formGroup.value?.expireTime,
          "EEE, MMM do, yyyy 'at' h:mm a",
          "yyyy-MM-dd'T'HH:mm:ss"
        );
      }
    }

    if (!this.deleteGroupFlag) {
      this.submitToUserProfile?.emit(userDetail);
    } else {
      this.userManagementService.updateUserGroupAccess(userDetail).subscribe({
        next: () => {
          if (this.ownProfile) {
            this.commonService.setOwnProfile(true);
          } else {
            this.commonService.setOwnProfile(false);
          }
          this.notificationService.showSuccess(
            this.commonService.stringInterPolation(
              this.translate.instant('UPDATED_SUCCESSFULLY'),
              this.translate.instant('GROUP')
            )
          );
          this.formGroup.patchValue({
            repeatStartTime: '',
          });
          this.formGroup.patchValue({
            repeatEndTime: '',
          });
          this.formGroup.patchValue({
            repeatDays: '',
          });
          this.stepperChange.emit((this.stepper = 1)); //redirect to profile detail
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('submit', err);
          this.notificationService.showError(err.message);
        },
      });
    }
  }

  /**
   * @description this function is responsible of validated start time & end time and set default value if not given
   * @returns Interface of Ishareaccess
   */
  startTimeEndTimeUpdate(): IShareAccess {
    const userDetail: IShareAccess = {};

    if (
      !(
        this.formGroup.value?.repeatStartTime &&
        this.formGroup.value?.repeatEndTime
      )
    ) {
      // default value MPC-6375
      userDetail.repeatStartTime = convertParseDateTime(
        '12:00 AM',
        'hh:mm a',
        'HH:mm'
      );
      userDetail.repeatEndTime = convertParseDateTime(
        '11:59 PM',
        'hh:mm a',
        'HH:mm'
      );
    } else {
      userDetail.repeatStartTime = convertParseDateTime(
        this.formGroup.value?.repeatStartTime,
        'hh:mm a',
        'HH:mm'
      );

      userDetail.repeatEndTime = convertParseDateTime(
        this.formGroup.value?.repeatEndTime,
        'hh:mm a',
        'HH:mm'
      );
    }
    return userDetail;
  }

  /**
   * @description toggle main form and time picker module and spit value editable for user
   * selected input pass for min and max validation
   * @param date
   * @returns void
   */
  selectDate(date: any, selectedInputName: string): void {
    this.formInstance.expireTime.markAsTouched();
    this.formInstance.startTime.markAsTouched();
    this.dateConversionforCalendar(selectedInputName);
    this.toggleDateForm = !this.toggleDateForm;
    this.calendarDate = date;
  }

  /**
   * @description date conversion for calendar format
   * @param selectedInputName date
   */
  dateConversionforCalendar(selectedInputName: string) {
    if (
      selectedInputName == 'startTime' &&
      this.formInstance['expireTime']?.value
    ) {
      this.calendarConvertedEndDate = new Date(
        convertParseDateTime(
          this.formInstance['expireTime']?.value,
          "EEE, MMM do, yyyy 'at' h:mm a",
          'yyyy-MM-dd'
        )
      );
    } else if (
      selectedInputName == 'expireTime' &&
      this.formInstance['startTime']?.value
    ) {
      this.calendarConvertedStartDate = new Date(
        convertParseDateTime(
          this.formInstance['startTime']?.value,
          "EEE, MMM do, yyyy 'at' h:mm a",
          'yyyy-MM-dd'
        )
      );
    }

    this.calendarValidateMinMax = selectedInputName;
  }

  /**
   * @description mat-calendar output method call and pass value into reactive control
   * @param value date
   * @returns void
   */
  updateFormDate(value: any): void {
    this.calendarDate.value = value;
  }

  /**
   * @description clear variable if value higher than given condition
   * @param ev current event target value reset if value higher than hour
   *  @returns void
   */
  checkHour(ev: any): void {
    if (
      ev.target.value > 12 ||
      ev.keyCode == 69 ||
      ev.keyCode == 187 ||
      ev.keyCode == 189 ||
      ev.keyCode == 107 ||
      ev.keyCode == 109 ||
      ev.target.value.length > 2
    ) {
      this.hour = '';
      this.meridiem = '';
      this.hourStartRepeatTime = '';
      this.meridiemStartRepeatTime = '';
      this.hourEndRepeatTime = '';
      this.meridiemEndRepeatTime = '';
    }
  }

  /**
   * @description clear variable if value higher than given condition
   * @param ev current event target value reset if value higher than minutes
   * @returns void
   */
  checkMinutes(ev: any): void {
    if (
      ev.target.value > 59 ||
      ev.keyCode == 69 ||
      ev.keyCode == 187 ||
      ev.keyCode == 189 ||
      ev.keyCode == 107 ||
      ev.keyCode == 109 ||
      ev.target.value.length > 2
    ) {
      this.minute = '';
      this.meridiem = '';
      this.minuteStartReapeatTime = '';
      this.meridiemStartRepeatTime = '';
      this.minuteEndReapeatTime = '';
      this.meridiemEndRepeatTime = '';
    }
  }

  /**
   * @description reset local variables state
   * @returns void
   */
  resetForm(): void {
    this.hour = '';
    this.minute = '';
    this.meridiem = '';

    this.hourStartRepeatTime = '';
    this.minuteStartReapeatTime = '';
    this.meridiemStartRepeatTime = '';

    this.hourEndRepeatTime = '';
    this.minuteEndReapeatTime = '';
    this.meridiemEndRepeatTime = '';
    this.errorMessage = ''; // empty start time and time message
    this.calendarConvertedEndDate = '';
    this.calendarConvertedStartDate = convertToSiteTimeZone(this.timeZone);
  }

  /**
   * @description after selected value from calendar picker need to transform value for view
   * @returns void
   */
  submitDateTime(): void {
    if (
      this.calendarDate.value &&
      !isNaN(Number(this.hour)) &&
      !isNaN(Number(this.minute)) &&
      this.meridiem
    ) {
      const calendarValue = convertDateTimeFormat(
        this.calendarDate.value,
        'yyyy-MM-dd'
      );
      const formatedDate = convertDateTimeFormat(
        `${calendarValue} ${this.hour}:${this.minute} ${this.meridiem}`,
        "EEE, MMM do, yyyy 'at' h:mm a"
      );

      this.formInstance[this.calendarDate.name].setValue(formatedDate);
      this.resetForm();
    } else {
      this.formInstance[this.calendarDate.name].setValue('');
      this.resetForm();
    }

    this.toggleDateForm = !this.toggleDateForm;
    this.calendarValidateMinMax = '';
  }

  /**
   * @description function will reset current control value
   * @param ev control pass
   * @returns void
   */
  removeValue(ev: any): void {
    ev.setValue('');
  }

  /**
   * @description repeat event fire after reapt true and add and remove necessary controls
   * @returns void
   */
  changeRepeat(el: HTMLElement): void {
    // need settimeout hack because html not render into dom
    setTimeout(() => {
      el?.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    }, 0);

    if (this.formInstance.repeat.value) {
      this.formInstance.startTime?.patchValue('');
      this.formInstance.expireTime?.patchValue('');
      this.addNewControl('repeatStartTime', true);
      this.addNewControl('repeatEndTime', true);
      this.addNewControl('repeatDays', true);
      this.formInstance?.repeatStartTime?.markAsTouched();
      this.formInstance?.repeatEndTime?.markAsTouched();
      this.formInstance?.repeatDays?.markAsTouched();
      this.resetForm();
    } else {
      this.removeControl('repeatStartTime');
      this.removeControl('repeatEndTime');
      this.removeControl('repeatDays');
      this.weekArray.map((x: any) => (x.active = false));
    }
  }

  /**
   * @description add new control for form control
   * @param controlName control name for creation
   * @returns void
   */
  addNewControl(controlName: string, required = false): void {
    let dCtrl = new FormControl();
    if (required) {
      dCtrl.setValidators(MFValidators.required);
    }
    this.formGroup.addControl(controlName, dCtrl);
    dCtrl.updateValueAndValidity();
  }

  /**
   * @description delete control dynamic from form group
   * @param controlName control name string given
   * @returns void
   */
  removeControl(controlName: string): void {
    this.formGroup.removeControl(controlName);
  }

  /**
   * @description set control select time into relavant variables for time edit case
   * @param time
   * @returns void
   */
  selectTime(time: any): void {
    this.toggletimeForm = !this.toggletimeForm;
    if (time.length > 0) {
      const repeatStartTimeobj = time[0]?.value; // start time
      const repeatEndTimeobj = time[1]?.value; // end time
      this.setStartTime(repeatStartTimeobj);
      this.setEndTime(repeatEndTimeobj);
    }
    this.startTimeObj = time;
  }

  /**
   * @description if start time contain value populate into object
   * @param repeatStartTimeobj  object of {value:'', name:''}
   * @returns void
   */
  setStartTime(repeatStartTimeobj: any): void {
    // set start time object value into control
    if (repeatStartTimeobj) {
      this.hourStartRepeatTime = repeatStartTimeobj.split(' ')[0].split(':')[0];
      this.minuteStartReapeatTime = repeatStartTimeobj
        .split(' ')[0]
        .split(':')[1];
      this.meridiemStartRepeatTime = repeatStartTimeobj.split(' ')[1];
    }
  }

  /**
   * @description if start time contain value populate into object
   * @param repeatStartTimeobj  object of {value:'', name:''}
   * @returns void
   */
  setEndTime(repeatEndTimeobj: any): void {
    // set end time object value into control
    if (repeatEndTimeobj) {
      this.hourEndRepeatTime = repeatEndTimeobj.split(' ')[0].split(':')[0];
      this.minuteEndReapeatTime = repeatEndTimeobj.split(' ')[0].split(':')[1];
      this.meridiemEndRepeatTime = repeatEndTimeobj.split(' ')[1];
    }
  }

  /**
   * @description check starttime & endtime endtime alway greater than start time
   * @returns boolean case
   */
  endTimeGrtThanStartTime(): boolean {
    let result = false;
    const startTime = new Date(
      convertParseDateTime(
        `${this.hourStartRepeatTime}:${this.minuteStartReapeatTime} ${this.meridiemStartRepeatTime}`,
        `hh:mm a`,
        `yyyy/MM/dd hh:mm a`
      )
    );
    const endTime = new Date(
      convertParseDateTime(
        `${this.hourEndRepeatTime}:${this.minuteEndReapeatTime} ${this.meridiemEndRepeatTime}`,
        `hh:mm a`,
        `yyyy/MM/dd hh:mm a`
      )
    );
    if (endTime.getTime() > startTime.getTime()) {
      result = true;
    }
    return result;
  }

  /**
   * @description set hours, minutes, meridiem into control
   * @returns void
   */
  submitStartTime(): void {
    if (
      !isNaN(Number(this.hourStartRepeatTime)) &&
      !isNaN(Number(this.minuteStartReapeatTime)) &&
      this.meridiemStartRepeatTime &&
      !isNaN(Number(this.hourEndRepeatTime)) &&
      !isNaN(Number(this.minuteEndReapeatTime)) &&
      this.meridiemEndRepeatTime &&
      this.endTimeGrtThanStartTime()
    ) {
      this.formInstance[this.startTimeObj[0].name].setValue(
        convertParseDateTime(
          `${this.hourStartRepeatTime}:${this.minuteStartReapeatTime} ${this.meridiemStartRepeatTime}`,
          'hh:mm a',
          'hh:mm a'
        )
      );

      this.formInstance[this.startTimeObj[1].name].setValue(
        convertParseDateTime(
          `${this.hourEndRepeatTime}:${this.minuteEndReapeatTime} ${this.meridiemEndRepeatTime}`,
          'hh:mm a',
          'hh:mm a'
        )
      );

      this.toggletimeForm = !this.toggletimeForm;
      this.resetForm();
    } else {
      this.errorMessage = this.translate.instant(
        'FAILED_END_TIME_GREATER_START_TIME'
      );
      this.formInstance[this.startTimeObj[0].name].setValue('');
      this.formInstance[this.startTimeObj[1].name].setValue('');
    }
  }

  /**
   * @description find index and updated latest array value into control
   * @param week get object of week
   * @returns void
   */
  AddRemoveDays(week: any): void {
    const index = this.weekArray.findIndex((x: any) => x.value === week.value);
    this.weekArray[index].active = !week.active;
    this.formInstance.repeatDays.patchValue(
      this.weekArray.filter((x: any) => x.active).map((y: any) => y.value)
    );
  }

  resetToggleFormState() {
    this.hour = '';
    this.minute = '';
    this.meridiem = '';

    this.hourStartRepeatTime = '';
    this.minuteStartReapeatTime = '';
    this.meridiemStartRepeatTime = '';
    this.hourEndRepeatTime = '';
    this.minuteEndReapeatTime = '';
    this.meridiemEndRepeatTime = '';

    this.toggleDateForm = false;
    this.toggletimeForm = false;
  }

  /**
   * @description this method closes the error message alert.
   */
  closeError(): void {
    this.errorMessage = '';
  }

  deleteGroup(): void {
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmRemoveDialogComponent,
      {
        title: this.translate.instant('DELETE_GROUP'),
        bodyText: this.translate.instant(
          'ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_GROUP'
        ),
        footerText: this.translate.instant(
          'BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO'
        ),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (!result) return;
      this.accountSettingService
        .deleteGroup([this.selectedGroup.userGroupId!], this.userId)
        .pipe(
          switchMap((res: any) => {
            if (this.ownProfile) {
              this.commonService.setOwnProfile(true);
            } else {
              this.commonService.setOwnProfile(false);
            }
            this.stepperChange.emit((this.stepper = 3)); //redirect to user groups list
            this.parentRouteParams;
            const criteria: ICriteria = {
              size: 10000,
              searchText: '',
              userGroupId: Utility.decodeFromBase64(
                this.parentRouteParams.userGroupId
              ),
            };
            return this.userManagementService.getDashboardUsers(criteria);
          })
        )
        .subscribe({
          next: (users: any) => {
            const id = this.utility.decodeFromBase64(this.parentRouteParams.id);
            if (users.users.find((user: any) => user.userId === id)) {
              this.router.navigate([
                '/dashboard/users',
                this.parentRouteParams.groupTypeName,
                this.parentRouteParams.userGroupId,
                this.parentRouteParams.id,
              ]);
            } else {
              this.router.navigate([
                '/dashboard/users',
                this.parentRouteParams.groupTypeName,
                this.parentRouteParams.userGroupId,
              ]);
            }
          },
          error: (err: Error) => {
            if (window.__dev__) console.log('deleteGroup', err);
          },
        });
    });
  }

  /**
   * @description #onReapeatToggleDisabled assigns the updated event returned from accessRight directive to slide toggle
   * @param event: boolean
   * @returns void
   */
  onReapeatToggleDisabled(event: boolean) {
    this.toggleDisabled = event;
  }

  /**
   * @description #onDoneDisabled assigns the updated event returned from accessRight directive to done button
   * @returns void
   */
  onDoneDisabled(event: boolean) {
    this.doneDisabled = event;
  }

  /**
   * @description #onExpireDisabled assigns the updated event returned from accessRight directive to expire buttton
   * @param event: boolean
   * @returns void
   */
  onExpireDisabled(event: boolean) {
    this.expireDisabled = event;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.userListsubscription?.unsubscribe();
  }
}
